export default __webpack_public_path__ + "static/media/Dreams.5298c4dd.png";